import React from "react";
import { createUseStyles } from "react-jss";
import { useData } from "../DataProvider";
import ReactTooltip from "react-tooltip";

const useStyles = createUseStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "6rem",

    "& .demand-logo": {
      backgroundImage: `url('https://images.folloze.com/image/upload/v1643793885/Manual%20upload/dbtv-logo-white__1.png')`,
      backgroundSize: "contain",
    },
    "& .categories": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      marginTop: "2rem",
    },
    "& .tooltip": {
      backgroundColor: "#bfda33 !important",
      color: "#25282d !important",
      fontFamily: "Inter-Light",
      fontWeight: "normal",
      fontSize: "1.1rem",
      maxWidth: "300px",
    },

    "& .logoContainer": {
      width: "14%",
      border: "0.15rem solid #707070",
      lineHeight: "2rem",
      borderRadius: "0.5rem",
      fontFamily: "SourceSansProLight",
      fontSize: "1.5rem",
      padding: "2rem 1rem",
      height: "8rem",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0.5rem",

      "& .category-logo": {
        objectFit: "contain",
        width: "100%",
        height: "auto",
      },

      "& a": {
        color: "#FFFFFF",
        textDecoration: "none",
      },
    },
  },
  "@media screen and (max-width: 980px)": {
    container: {
      "& .categories": {
        flexWrap: "wrap",
        justifyContent: "center",
        marginBottom: 0,

        "& .logoContainer": {
          width: "20%",
          margin: "0.3rem",
          fontSize: "1rem",
        },
      },
    },
  },
  "@media screen and (max-width: 768px)": {
    container: {
      "& .categories": {
        flexWrap: "wrap",
        justifyContent: "center",
        marginBottom: 0,

        "& .tooltip": {
          display: "none",
        },

        "& .logoContainer": {
          width: "25%",
          margin: "0.3rem",
          padding: "1rem",
          fontSize: "1rem",
        },
      },
    },
  },
});

function CategoryBox(props) {
  const image = props.category?.images?.find(
    (i) => i.displayable_section === "logo"
  );

  const navigateToCategory = (e) => {
    e.preventDefault();

    const categoryContainer = document.querySelector(
      `#category-${props.category?.slug}`
    );
    window.scrollTo(0, categoryContainer.getBoundingClientRect().y - 150);
  };

  return (
    <div className="logoContainer" data-tip={props.category?.description}>
      <a
        onClick={navigateToCategory}
        href={`#category-${props.category?.slug}`}
      >
        {!image && props.category?.name}
        {image && (
          <img
            className="category-logo"
            alt={props.category?.name}
            src={window.FollozeApi.getImageUrl(image)}
            width="172px"
            height="71px"
          />
        )}
      </a>
      <ReactTooltip
        effect="solid"
        type="info"
        className="tooltip"
        arrowColor="#bfda33"
      />
    </div>
  );
}

function Header() {
  const classes = useStyles();
  const data = useData();
  const { categories } = data;
  // debugger

  const categoriesCount = categories?.categories_ids;

  React.useEffect(() => {
    if (categoriesCount > 0) {
      const appLoader = document.querySelector("#app-loader");
      if (appLoader) {
        appLoader.style.display = "none";
      }
    }
  }, [categoriesCount]);

  return (
    <>
      <div className={classes.container}>
        <div className="demand-logo smart-image square disabled image-type dbtv-top-image fallback-logo" />
        <div className="categories">
          {categories?.categories_ids?.map((id) => (
            <CategoryBox key={id} category={categories?.data[id]} />
          ))}
        </div>
      </div>
    </>
  );
}

export default Header;
